export type ContestCouponQrLinkInput = {
  couponCode?: string | null;
  contestId?: string | null;
  fallbackLink?: string | null;
};

export type ContestTokenQrLinkInput = {
  token?: string | null;
  fallbackLink?: string | null;
};

export function buildContestCouponQrLink(input: ContestCouponQrLinkInput): string | null {
  const couponCode = input.couponCode?.trim();
  const contestId = input.contestId?.trim();

  if (!couponCode || !contestId) {
    return input.fallbackLink ?? null;
  }

  const params = new URLSearchParams({
    code: couponCode,
    contestId,
  });

  return `noahsark://contest-coupon?${params.toString()}`;
}

export function buildContestTokenQrLink(input: ContestTokenQrLinkInput): string | null {
  const token = input.token?.trim();

  if (!token) {
    return input.fallbackLink ?? null;
  }

  const params = new URLSearchParams({ token });
  return `noahsark://contest-coupon?${params.toString()}`;
}
